// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-7f65f78a].el-dialog{\r\n  margin-top: 0 !important;\n}\n[data-v-7f65f78a].el-dialog__wrapper{\r\n  position: fixed !important;\r\n  overflow: auto !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
